export default ["I'll Get You Next Time!", "🔥🔥🔥"];
